export default __webpack_public_path__ + "static/media/8.ccce2a4c.jpg";